/**
 * @module api-scm:orderManage/orderConfirm
 */
import service from '@/service'

export function markUrgent(data) {
  return service['api-scm']({
    url: '/scm/order/orderConfirm/markUrgent',
    method: 'post',
    data
  })
}

export function cancelUrgent(data) {
  return service['api-scm']({
    url: '/scm/order/orderConfirm/cancelUrgent',
    method: 'post',
    data
  })
}

/**
 * 列表查询
 * @param {{
 * keywords:string,
 * limit:number,
 * page:number,
 * sort:string
 * }} data
 */
export function getList(data) {
  return service['api-scm']({
    url: '/scm/order/orderConfirm/get/getList',
    method: 'post',
    data,
    headers: { 'Content-Type': 'application/json' }
  })
}

export function getUserPullList(params) {
  return service['api-web']({
    url: '/public/hr/getUserPullList',
    method: 'get',
    params
  })
}

export function info(id) {
  return service['api-scm']({
    url: '/scm/order/orderConfirm/get/infoAll',
    method: 'get',
    params: { id },
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}
/**
 * @param {{keywords:string,id:(string|number)}} params
 * @descrption 根据商品名称/编码查询当前拆单明细
 */
export function querySepareteDetail(params) {
  return service['api-scm']({
    url: '/scm/order/orderConfirm/get/querySepareteDetail',
    method: 'get',
    params: params,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}
/**
 * @description 拆单详情下拉列表
 */
export function getSeparateListPull(params) {
  return service['api-scm']({
    url: '/scm/order/orderConfirm/info/getList',
    method: 'get',
    params
  })
}

/**
 * @param {{ids:string}} params
 * @description 拆单详情删除
 */
export function orderConfirmRemove(params) {
  return service['api-scm']({
    url: '/scm/order/orderConfirm/delete',
    method: 'delete',
    params,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}
/**
 * @description 保存拆单明细
 */
export function saveOrderDetailSku(data) {
  return service['api-scm']({
    url: '/scm/order/orderConfirm/save',
    method: 'post',
    data,
    tipTypes: 'none'
  })
}
/**
 * @description 拆单修改
 */
export function orderConfirmUpdate(data) {
  return service['api-scm']({
    url: '/scm/order/orderConfirm/update',
    method: 'post',
    data
  })
}
/**
 * @param {{modeDespatch:number,deliveryWarehouse?:string}} params
 * @description 拆单明细 发货仓/调出仓库下拉,
 * 筛选表单查询订单时，使用 { modeDespatch:1 } 发货方式为采购时的仓库
 */
export function getAllocateWarehouse(params) {
  return service['api-scm']({
    url: '/scm/order/orderConfirm/get/getAllocateWarehouse',
    method: 'get',
    params
  })
}

/**
 * @param {*}
 * @description 发货仓
 */
export function getDeliveryWarehouse(params) {
  return service['api-scm']({
    url: '/public/order/get/getWarehouse',
    method: 'get',
    params
  })
}

/**
 * @description  待拆单页面拆单明细选择调拨仓带出可调拨数量allocateWarehouse:多个调拨仓code','隔开
 */
export function getAllocateNumber(params) {
  return service['api-scm']({
    url: '/scm/order/orderConfirm/get/getAllocateNumber',
    method: 'get',
    params
  })
}

/**
 * @description 待拆单页面拆单明细选择仓库带出商品可用量
 */
export function getAvailableNumber(params) {
  return service['api-scm']({
    url: '/scm/order/orderConfirm/get/getAvailableNumber',
    method: 'get',
    params
  })
}

/**
 * @param {{productCode:string}} params
 * @description 拆单采购时下拉商品对应的所有采购人员
 * @see /src/service/api-web/index.js - getBuyerByProductCode
 * @see /public/product/queryBuyerByProductCode
 */
export function getPurchaseUser(params) {
  return service['api-scm']({
    url: '/scm/order/orderConfirm/get/recommendBuyer',
    method: 'get',
    params,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 * @param {string} orderCode
 * @description  确认拆单
 */
export function confirmSeparate(data) {
  return service['api-scm']({
    url: '/scm/order/orderConfirm/confirmSeparate',
    method: 'post',
    data,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    useWarningTypeWhenCode100: true
  })
}
/**
 * @param {string} orderCode
 * @description  批量拆单
 */
export function batchSeparateOrder(data) {
  return service['api-scm']({
    url: '/scm/order/orderConfirm/batchSeparateOrder',
    method: 'post',
    data,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}
/**
 * @param {string} orderCode
 * @description  是否有售后订单
 */
export function afterSaleOrNot(data) {
  return service['api-scm']({
    url: '/public/order/afterSaleOrNot',
    method: 'post',
    data,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}
/**
 * @param {string} code
 * @description  重新匹配
 */
export function anewMatching(code) {
  return service['api-scm']({
    url: '/scm/order/orderConfirm/anewMatching',
    method: 'post',
    data: { code },
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 * @param {{productCode:string,separateId:string}} params
 * @description  拆单内部联络单详情
 */
export function interiorLiaisonDetail(params) {
  return service['api-scm']({
    url: '/scm/order/orderConfirm/interiorLiaison/info',
    method: 'get',
    params,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 * @param {object} data
 * @description  拆单内部联络单新增
 */
export function interiorLiaisonSave(data) {
  return service['api-scm']({
    url: '/scm/order/orderConfirm/interiorLiaison/save',
    method: 'post',
    data
  })
}

/**
 * @param {object} data
 * @description 联络单列表
 */
export function interiorLiaisonQueryList(data) {
  return service['api-scm']({
    url: '/scm/order/orderConfirm/interiorLiaison/queryList',
    method: 'post',
    data
  })
}
/**
 * @param {object} data
 * @description 联络单修改
 */
export function interiorLiaisonUpdate(data) {
  return service['api-scm']({
    url: '/scm/order/orderConfirm/interiorLiaison/update',
    method: 'post',
    data
  })
}
/**
 * @param {string} orderCode
 * @description  终结弹窗中的商品下拉
 */
export function queryOrderDetail(orderCode) {
  return service['api-scm']({
    url: '/scm/order/orderConfirm/get/queryOrderDetail',
    method: 'get',
    params: { orderCode },
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}
/**
 * @param {string} orderCode
 * @description  终结弹窗中的商品表格
 */
export function queryEndOrderDetail(orderCode) {
  return service['api-scm']({
    url: '/scm/order/orderConfirm/get/queryEndOrderDetail',
    method: 'get',
    params: { orderCode },
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}
/**
 * @param {object} data
 * @description  终结商品/取消终结，使用参数字段 数组控制新增终结和取消终结，
 * 如：空数组即为取消所有终结
 */
export function endOrderDetail(data) {
  return service['api-scm']({
    url: '/scm/order/orderConfirm/endOrderDetail',
    method: 'post',
    data
  })
}
/**
 * @param {number} ids
 * @description 作废
 */
export function invalid(ids) {
  return service['api-scm']({
    url: '/scm/order/orderInfo/cancellationOrder',
    method: 'post',
    data: { ids },
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 * 确认拆单提醒
 */
export function getRemainRules(params) {
  return service['api-web']({
    url: '/cc/orderRemainCenter/get/getRemainRules',
    method: 'get',
    params,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 * @param {{keywords:string=}} params
 * @description 下拉选项：用户 (根据真实姓名 name 字段 模糊查询)
 */
export function getUserOpts(params) {
  return service['api-web']({
    url: '/public/findUserList',
    method: 'get',
    params,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 * @description 批量修改卖家备注
 */
export function batchUpdateSellerRemark(data) {
  return service['api-scm']({
    url: '/scm/order/orderConfirm/batch/updateSellerRemark',
    method: 'post',
    data
  })
}
/**
 * @param {object} data
 * @description 修改收货地址
 */
export function editReceiveGoodsAddress(data) {
  return service['api-scm']({
    url: '/scm/order/orderConfirm/editReceiveGoodsAddress',
    method: 'post',
    data,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 * @param {object} data
 * @description 修改收货地址
 */
export function updateReceivingInfo(data) {
  return service['api-scm']({
    url: '/public/order/updateReceivingInfo',
    method: 'post',
    data
  })
}

/**
 * @param {number} businessState
 * @param {Array} orderIdList
 * @description 订单整单关闭-反关闭
 */
export function orderClose(data) {
  return service['api-scm']({
    url: '/scm/order/orderInfo/orderClose',
    method: 'post',
    data
  })
}
/**
 * @description 系统标签数量接口
 */
export function getSystemMarkAmount(params) {
  return service['api-scm']({
    url: '/scm/order/orderConfirm/get/getSystemMarkAmount',
    method: 'get',
    params,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 * @description 刷新系统标签
 */
export function flushSystemMark(params) {
  return service['api-scm']({
    url: '/scm/order/orderConfirm/flushSystemMark',
    method: 'get',
    params,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 * @description 获取所有启用的订单标记
 */
export function getAllEnableOrderMark(params) {
  return service['api-web']({
    url: '/sys/orderMark/get/getAllEnableOrderMark',
    method: 'get',
    params,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 * @param {{keywords:string}} params
 */
export function getUserlists(params) {
  return service['api-web']({
    url: '/public/getUserlists',
    method: 'get',
    params,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 * @description 物流商模糊下拉
 * @param {{carrierName:string}} params
 */
export function findCarrierList(params) {
  return service['api-scm']({
    url: '/public/logistics/findCarrierList',
    method: 'get',
    params: {
      ...params,
      flag: 0 // 启用
    },
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 * @param {Array} codes
 * @param {number} flag
 * @param {string} logisticsProvidersCode
 * @description 更新物流公司
 */
export function updateLogistics(data) {
  return service['api-scm']({
    url: '/scm/order/orderConfirm/batch/updateLogistics',
    method: 'post',
    data
  })
}

/**
 *
 * @description 修改终结数量
 */
export function updateOrderDetailEndNumber(data) {
  return service['api-scm']({
    url: '/scm/order/orderConfirm/batch/updateOrderDetailEndNumber',
    method: 'post',
    data
  })
}

/**
 *
 * @description 自动让利 让前端展示 不落库
 */
export function findShareDetailMoney(data) {
  return service['api-scm']({
    url: '/scm/order/orderConfirm/findShareDetailMoney',
    method: 'post',
    data
  })
}

/**
 *
 * @description 批量替换
 */
export function batchUpdateDetail(data) {
  return service['api-scm']({
    url: '/scm/order/orderConfirm/batch/batchUpdateDetail',
    method: 'post',
    data
  })
}

/**
 *
 * @description 新增明细
 */
export function insertSku(data) {
  return service['api-scm']({
    url: '/scm/order/orderConfirm/batch/insertSku',
    method: 'post',
    data
  })
}

/**
 * 模糊查询商品code的下拉
 * @param {{code?:string,supplierCode?:string}} params
 */
export function getAncillaryCode(params) {
  return service['api-web']({
    url: '/public/product/getAncillaryCode',
    method: 'get',
    params
  })
}

/**
 * 店铺模糊查询下拉框（下拉公用）
 */
export function getStorePullOpts(params) {
  return service['api-web']({
    url: '/public/data/getStorePull',
    method: 'get',
    params,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 * @description 下发仓库
 * @param {} data
 */
export function issuedToWarehouse(data) {
  return service['api-scm']({
    url: '/scm/order/orderConfirm/issuedToWarehouse',
    method: 'post',
    data
  })
}

/**
 * 解绑
 */
export function untie(data) {
  return service['api-scm']({
    url: '/scm/order/orderConfirm/untie',
    method: 'post',
    data,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    tipTypes: 'none'
  })
}

/**
 * 根据商品编码获取所有库存信息
 */
export function getInventoryDetailByProductCode(params) {
  return service['api-scm']({
    url: '/public/inventory/getInventoryDetailByProductCode',
    method: 'get',
    params,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 * 待确认页面 校验订单是否可以部分拆单
 */
export function judgeOrderWhetherOrNotToOpenOrderInOrderConfirm(params) {
  return service['api-scm']({
    url: '/public/order/judgeOrderWhetherOrNotToOpenOrderInOrderConfirm',
    method: 'get',
    params,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 * 更新物流公司前置校验
 */
export function updateLogisticsPreCheck(data) {
  return service['api-scm']({
    url: '/public/order/updateLogisticsPreCheck',
    method: 'post',
    data,
    headers: { 'Content-Type': 'application/json' }
  })
}

/**
 * 获取下游库存调拨单号
 */
export function getSeparateRelationWarehouseAllotCode(params) {
  return service['api-scm']({
    url: '/public/order/getSeparateRelationWarehouseAllotCode',
    method: 'get',
    params,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 * 待确认 - 是否可以修改
 */
export function judgeOrderCanUpdate(data) {
  return service['api-scm']({
    url: '/public/order/judgeOrderCanUpdate',
    method: 'post',
    data
  })
}

/**
 * checkInventoryNumberIsEnough - task/4542
 */
export function checkInventoryNumberIsEnough(params) {
  return service['api-scm']({
    url: '/public/inventory/checkInventoryNumberIsEnough',
    method: 'get',
    params,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 * 查询sku在指定仓库下的总库存量和剩余总可用量
 */
export function queryBatchSkuInventoryByWarehouse(params) {
  return service['api-scm']({
    url: 'public/inventory/queryBatchSkuInventoryByWarehouse',
    method: 'get',
    params,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 *
 * @description 切换为仓库直发，自动带出发货仓
 */
export function changeWarehouse(data) {
  return service['api-scm']({
    url: '/public/inventory/changeWarehouse',
    method: 'post',
    data
  })
}

/**
 * 批量修改发货方式
 */
export function batchUpdateModeDesPatch(data) {
  return service['api-scm']({
    url: '/scm/order/orderConfirm/batchUpdateModeDesPatch',
    method: 'post',
    data
  })
}

/**
 * 批量修改发货仓
 */
export function batchUpdateWarehouse(data) {
  return service['api-scm']({
    url: '/scm/order/orderConfirm/batchUpdateWarehouse',
    method: 'post',
    data
  })
}

/**
 * 批量修改附加信息
 */
export function batchUpdateSubjoinHandoverRemark(data) {
  return service['api-scm']({
    url: '/scm/order/orderConfirm/batch/updateSubjoinHandoverRemark',
    method: 'post',
    data
  })
}

/**
 * 批量修改附加信息-明细
 */
export function batchUpdateSubjoinHandoverRemarkDetailId(data) {
  return service['api-scm']({
    url: '/scm/order/orderSeparate/batch/updateSubjoinHandoverRemarkByDetailId',
    method: 'post',
    data
  })
}

/**
 * 批量修改待拆单采购备注
 */
export function batchUpdatePurchaseRemark(data) {
  return service['api-scm']({
    url: '/scm/order/orderSeparate/batch/updatePurchaseRemark',
    method: 'post',
    data
  })
}

/**
 * 批量修改待确认采购备注
 */
export function batchUpdateOrderConfirmPurchaseRemark(data) {
  return service['api-scm']({
    url: '/scm/order/orderConfirm/batch/updatePurchaseRemark',
    method: 'post',
    data
  })
}

/**
 * 批量修改采购备注-明细
 */
export function batchUpdatePurchaseRemarkDetailId(data) {
  return service['api-scm']({
    url: '/scm/order/orderSeparate/batch/updatePurchaseRemarkByDetailId',
    method: 'post',
    data
  })
}

/**
 * 批量作废--待确认
 */
export function batchInvalid(data) {
  return service['api-scm']({
    url: '/scm/order/orderConfirm/batchCancellationOrder',
    method: 'post',
    data
  })
}
export function getCheckSeparateDetailChange(data) {
  return service['api-scm']({
    url: '/public/order/checkSeparateDetailChange',
    method: 'post',
    data
  })
}

/**
 *
 *待确认批量导出
 */
export function exportToBeConfirmed(data) {
  return service['api-scm']({
    url: '/scm/order/orderConfirm/exportToBeConfirmed',
    method: 'post',
    data
    // headers: { 'Content-Type': 'application/json' }
  })
}

/**
 * @param {Array} codes
 * @param {number} flag
 * @param {string} logisticsProvidersCode
 * @description 更新物流公司
 */
export function updateLogisticsCompany(data) {
  return service['api-scm']({
    url: '/scm/order/orderConfirm/updateLogisticsCompany',
    method: 'post',
    data
  })
}

/**
 * @param {{modeDespatch:number,deliveryWarehouse?:string}} params
 * @description 拆单明细 发货仓/调出仓库下拉,  组织间结算
 * 筛选表单查询订单时，使用 { modeDespatch:1 } 发货方式为采购时的仓库
 */
export function getAllocateWarehouseOS(params) {
  return service['api-web']({
    url: '/public/warehouse/getAllocateWarehousePull4OrgesIn',
    method: 'get',
    params,
    headers: { 'Content-Type': 'application/json' }
  })
}

/**
 * @param  params
 * @description
 * queryUnbindInfoBySeparateProductId
 */
export function queryUnbindInfoBySeparateProductId(params) {
  return service['api-scm']({
    url: '/public/order/queryUnbindInfoBySeparateProductId',
    method: 'get',
    params,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 *查询采购进度
 */
export function getPurchaseProgress(params) {
  return service['api-scm']({
    url: '/scm/order/orderConfirm/getPurchaseProgress',
    method: 'get',
    params,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 *待确认采购进度导出
 */
export function purchaseProgressExport(data) {
  return service['api-scm']({
    url: '/scm/order/orderConfirm/orederConfirmPurchaseProgressExport',
    method: 'post',
    data
  })
}
